<template>
  <div class="body-container">
    <Header />
    <b-container class="content" fluid>
      <b-row class="h-100">
        <!--NUXT HERE -->
        <nuxt />
      </b-row>
    </b-container>
    <Footer />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import axios from 'axios'
import Header from '@/components/common/Header'
import Footer from '@/components/common/Footer'

export default {
  components: {
    Header,
    Footer
  },
  data () {
    return {}
  },
  computed: mapState(['user']),
  head () {
    return {
      script: [
        {
          hid: 'AFrame',
          src: 'https://aframe.io/releases/1.4.1/aframe.min.js'
        },
        {
          hid: 'AFrameExtras',
          src:
            'https://cdn.jsdelivr.net/gh/donmccurdy/aframe-extras@v6.1.1/dist/aframe-extras.min.js',
          defer: true
        }
      ]
    }
  }
}
</script>

<style>
html {
  font-family: 'Raleway', sans-serif;
  font-size: 16px;
  word-spacing: 1px;
  -ms-text-size-adjust: 100%;
  -webkit-text-size-adjust: 100%;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  box-sizing: border-box;
  height: 100%;
}

body {
  font-family: 'Raleway', sans-serif;
  background-color: white;
}

.body-container {
  display: flex;
  min-height: 100vh;
  flex-direction: column;
}

.content {
  flex: 1;
}

.footer {
  margin-top: auto;
}

*,
*:before,
*:after {
  box-sizing: border-box;
  margin: 0;
}
</style>
